export const getMessages = (state) => state.chatMessage.messageList;
export const getChatUsers = (state) => state.chatMessage.chatUserList;
export const getMessageDetails = (state) => state.chatMessage.messageDetails;
